<template>
  <div class="dashboard">
    <v-img
      class="bg_img"
      :src="
        allDevices.length
          ? require('../../assets/img/bg_error.jpg')
          : require('../../assets/img/bg_OK.jpg')
      "
    >
      <div class="status" v-if="allDevices.length">
        <v-icon class="error-list" color="red">warning</v-icon>
        <div class="dashboard-title">
          <strong>Se han detectado fallas</strong>
        </div>
      </div>
      <div class="status" v-else>
        <v-icon class="success-list" color="green"
          >done</v-icon
        >
        <div class="dashboard-title">
          <strong>No se detectan fallas</strong>
        </div>
      </div>
      <v-card pa-2 class="rounded">
        <v-list v-if="allDevices.length" id="errorList" class="spacious">
          <template v-for="(item, index) in allDevices">
            <v-divider v-if="index != 0" :key="index"></v-divider>

            <v-list-tile
              :key="item.title"
              avatar
              append
              @click="openDevice(item)"
              style="content-visibility: auto"
            >
              <v-list-tile-avatar>
                <svg
                  class="svg-icon"
                  xmlns="http://www.w3.org/2000/svg"
                  v-if="item.DeviceType.id == 2"
                >
                  <rect
                    y="10"
                    x="4"
                    fill="#f93a2f"
                  />
                </svg>
                <v-icon
                  v-else
                  color="#f93a2f"
                  >trip_origin</v-icon
                >
              </v-list-tile-avatar>

              <v-list-tile-content>
                <strong
                  ><v-list-tile-title
                    v-html="item.name"
                  ></v-list-tile-title
                ></strong>
                <v-list-tile-sub-title>{{
                  item.Crops.length
                    ? item.Crops[0].name
                    : 'Sin datos'
                }}</v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-icon>arrow_forward_ios</v-icon>
              </v-list-tile-action>
            </v-list-tile>
          </template>
        </v-list>
      </v-card>
    </v-img>
    <devices-events />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { DEVICES_FAILING_QUERY, USER_QUERY } from '../../constants/graphql';
import Events from './Events';

export default {
  name: 'dashboard',
  components: {
    'devices-events': Events
  },
  data () {
    return {
      allDevices: [],
      skipDevicesQuery: true,
      User: {}
    };
  },
  apollo: {
    User: {
      query: USER_QUERY,
      variables () {
        return {
          id: this.$store.getters.user.id
        };
      },
      result () {
        this.skipDevicesQuery = false;
      },
      error () {
        this.skipDevicesQuery = false;
      }
    },
    allDevices: {
      query: DEVICES_FAILING_QUERY,
      variables () {
        return {
          organizationIds: this.User.Organization.map(org => org.id)
        };
      },
      skip () {
        return this.skipDevicesQuery;
      }
    }
  },
  computed: {
    ...mapGetters(['devices', 'user']),
    window () {
      return {
        width: this.$store.getters.width,
        height: this.$store.getters.height
      };
    }
  },
  methods: {
    openDevice (item) {
      mixpanel.track('Open device in list', {'id': item.id});
      gtag('event', 'open_device_in_list', {event_category: 'click', event_label: 'Open device in list', value: item.id});
      this.$router.push({ name: 'DeviceDetail', params: { id: `${item.id}` } });
    }
  }
};
</script>


// WEBPACK FOOTER //
// DashboardMainScreen.vue?5e67b751